import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "closeOnClickAway", "closeOnEscape", "closeOnInvisible", "closeOnResize", "closeOnScroll", "closeOnSelection", "currentDate", "defaultValue", "disabled", "displayFormat", "lockScrolling", "maximumDate", "minimumDate", "offset", "onClose", "onOpen", "onValueChange", "openOnClick", "openOnFocus", "openOnHover", "position", "rightIcon", "showTrailingDates", "value"];
import { ChevronDown } from '@flowio/react-icons';
import { TextInput } from '@flowio/react-text-input';
import { Calendar } from '@flowio/react-calendar';
import { Popover } from '@flowio/react-popover';
import moment from 'moment-timezone';
import React from 'react';
var defaultProps = {
  closeOnClickAway: true,
  closeOnEscape: true,
  closeOnInvisible: false,
  closeOnResize: false,
  closeOnScroll: false,
  closeOnSelection: true,
  disabled: false,
  displayFormat: 'll',
  lockScrolling: true,
  offset: '0px 2px',
  openOnClick: true,
  openOnFocus: true,
  openOnHover: false,
  position: 'bottom left',
  rightIcon: ChevronDown,
  showTrailingDates: true
};

function getInitialState(props) {
  var defaultValue = props.defaultValue,
      value = props.value;
  return {
    open: false,
    // An undefined default value will result in a moment instance
    // with the current date and time.
    value: value != null ? moment(value) : moment(defaultValue)
  };
}

var DateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInput, _React$Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);
    _this.state = getInitialState(props);
    _this.handleDateChange = _this.handleDateChange.bind(_assertThisInitialized(_this));
    _this.handlePopoverClose = _this.handlePopoverClose.bind(_assertThisInitialized(_this));
    _this.handlePopoverOpen = _this.handlePopoverOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value;

      if (value != null) {
        this.setState({
          value: moment(value)
        });
      }
    }
  }, {
    key: "handleDateChange",
    value: function handleDateChange(date) {
      var _this$props = this.props,
          closeOnSelection = _this$props.closeOnSelection,
          onValueChange = _this$props.onValueChange,
          value = _this$props.value;
      var prevDate = this.state.value;
      var isOpen = !closeOnSelection || prevDate.isSame(date, 'day');

      if (value == null) {
        this.setState({
          open: isOpen,
          value: date
        });
      } else {
        this.setState({
          open: isOpen
        });
      }

      if (onValueChange != null) {
        onValueChange(date);
      }
    }
  }, {
    key: "handlePopoverOpen",
    value: function handlePopoverOpen() {
      this.open();
    }
  }, {
    key: "handlePopoverClose",
    value: function handlePopoverClose() {
      this.close();
    }
  }, {
    key: "close",
    value: function close() {
      var onClose = this.props.onClose;
      this.setState({
        open: false
      }, onClose);
    }
  }, {
    key: "open",
    value: function open() {
      var onOpen = this.props.onOpen;
      this.setState({
        open: true
      }, onOpen);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          closeOnClickAway = _this$props2.closeOnClickAway,
          closeOnEscape = _this$props2.closeOnEscape,
          closeOnInvisible = _this$props2.closeOnInvisible,
          closeOnResize = _this$props2.closeOnResize,
          closeOnScroll = _this$props2.closeOnScroll,
          closeOnSelection = _this$props2.closeOnSelection,
          currentDate = _this$props2.currentDate,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          displayFormat = _this$props2.displayFormat,
          lockScrolling = _this$props2.lockScrolling,
          maximumDate = _this$props2.maximumDate,
          minimumDate = _this$props2.minimumDate,
          offset = _this$props2.offset,
          onClose = _this$props2.onClose,
          onOpen = _this$props2.onOpen,
          onValueChange = _this$props2.onValueChange,
          openOnClick = _this$props2.openOnClick,
          openOnFocus = _this$props2.openOnFocus,
          openOnHover = _this$props2.openOnHover,
          position = _this$props2.position,
          rightIcon = _this$props2.rightIcon,
          showTrailingDates = _this$props2.showTrailingDates,
          valueOnProps = _this$props2.value,
          unhandledProps = _objectWithoutProperties(_this$props2, _excluded);

      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      return /*#__PURE__*/React.createElement(Popover, {
        className: className,
        closeOnClickAway: closeOnClickAway,
        closeOnEscape: closeOnEscape,
        closeOnInvisible: closeOnInvisible,
        closeOnResize: closeOnResize,
        closeOnScroll: closeOnScroll,
        disabled: disabled,
        lockScrolling: lockScrolling,
        offset: offset // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onClose: this.handlePopoverClose // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onOpen: this.handlePopoverOpen,
        open: open,
        openOnClick: openOnClick,
        openOnFocus: openOnFocus,
        openOnHover: openOnHover,
        position: position,
        tabIndex: -1,
        trigger: /*#__PURE__*/React.createElement(TextInput, _extends({}, unhandledProps, {
          clearable: false,
          disabled: disabled,
          readOnly: true,
          rightIcon: rightIcon,
          value: value.format(displayFormat)
        }))
      }, /*#__PURE__*/React.createElement(Calendar, {
        borderless: true,
        currentDate: currentDate,
        maximumDate: maximumDate,
        minimumDate: minimumDate // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onSelectionChange: this.handleDateChange,
        selectedDate: value,
        showTrailingDates: showTrailingDates
      }));
    }
  }]);

  return DateInput;
}(React.Component);

_defineProperty(DateInput, "displayName", 'DateInput');

_defineProperty(DateInput, "defaultProps", defaultProps);

export default DateInput;